import { WifiOff } from "lucide-react";
import { useNetworkStatus } from "@/hooks/useNetworkStatus";

export const NetworkStatusBanner = () => {
  const { isOnline, offlineAt } = useNetworkStatus();

  if (isOnline) {
    return null;
  }

  return (
    <div className="bg-amber-50 border-b border-amber-200 text-amber-900 text-sm">
      <div
        className="mx-auto flex max-w-4xl items-center gap-2 px-4 py-2"
        role="status"
        aria-live="assertive"
      >
        <WifiOff className="h-4 w-4 flex-shrink-0" aria-hidden="true" />
        <p>
          You are currently offline. Changes will resume once you’re reconnected{" "}
          {offlineAt
            ? `(lost connection at ${offlineAt.toLocaleTimeString()})`
            : null}
          .
        </p>
      </div>
    </div>
  );
};

export default NetworkStatusBanner;
